import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibInfoFilledIconModule } from '../icons/lib-info-filled-icon/lib-info-filled-icon.module';
import { LibRefreshIconModule } from '../icons/lib-refresh-icon/lib-refresh-icon.module';
import { LibButtonModule } from '../lib-button/lib-button.module';
import { LibFlashMessageComponent } from './lib-flash-message.component';

@NgModule({
  imports: [CommonModule, LibButtonModule, LibRefreshIconModule, LibInfoFilledIconModule],
  declarations: [LibFlashMessageComponent],
  exports: [LibFlashMessageComponent],
})
export class LibFlashMessageModule {}
